import { Navigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { InviteeList, InviteForm } from '@/components/invitations';
import { INVITE_FIELDS } from '@gg/shared';
import { BackButton, Eyebrow } from '@/components/ui';
import { useMe, useReferral } from '@/lib/queries';

/** Screen 04b: invite more people from the profile (P-07, PRD §14 assumption). */
export function Invite() {
  const { t } = useTranslation();
  const me = useMe();
  const referral = useReferral(Boolean(me.data));

  if (me.isLoading) return <p className="text-center text-ink-muted">…</p>;
  if (me.isError || !me.data) return <Navigate to="/login" replace />;
  if (!referral.data) return <p className="text-center text-ink-muted">…</p>;

  const { chances, invites } = referral.data;

  return (
    <section className="flex flex-1 flex-col gap-5">
      <div className="flex items-center gap-3">
        <BackButton to="/me" label={t('referral.back')} />
        <Eyebrow>
          {t('referral.eyebrow', { chances: t('referral.chances', { count: chances }) })}
        </Eyebrow>
      </div>

      <div className="flex flex-1 flex-col gap-4">
        <div className="flex flex-col gap-1">
          <h1 className="m-0 font-display text-section-lg font-bold">
            {t('invite.fromProfile.title')}
          </h1>
          <p className="m-0 text-sm leading-snug text-ink-muted">
            {t('invite.fromProfile.subtitle')}
          </p>
        </div>
        <InviteeList invites={invites} variant="boxed" />
        <InviteForm fields={INVITE_FIELDS} draftKey="invite" />
      </div>
    </section>
  );
}
